import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../core/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class UrlConfigurationService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService) { }

  regionOptionsAPI =  "/api/gtrgonopts";
  countryOptionsAPI =  "/api/gtcuntryopts";
  jurisdictionOptionsAPI =  "/api/gtjursdctonopts";
  regulatorOptionsAPI =  "/api/gtrgltropts";
  regulatorOptionsAPI_InsuranceACQ =  "/api/gtrgltroptsinsACQ";
  docTypeOptionsAPI =  "/api/gtdctypopts";
  docTypeOptionsAPI_InsuranceACQ =  "/api/gtdctypoptsinsACQ";
  industryOptionsAPI =  "/api/gtindstyopts";
  updateTypeOptionsAPI =  "/api/gtupdttypopts";
  seleniumRequiredOptionsAPI = "/api/getseleniumrequiredoptions";
  clickEventTypeMasterAPI = "/api/getclickeventtypemasterdata";
  regLakeStatusOptionsAPI =  "/api/gtrglakstatsopts";
  insuranceAcquisitionRuleOptionsAPI =  "/api/gtinsacqrulopts";
  scheduleOptionsAPI =  "/api/gtshdleopts";
  langaugeOptionsAPI =  "/api/gtlngagropts";
  assigneeOptionsAPI =  "/api/gtasigneopts";
  fillingDateFormatMasterOptions =  "/api/gtfilngopts";

  urlConfigurationByIdAPI =  "/api/gturlcnfgrtondtlsbyid";

  addAPI =  "/api/adurlcnfgrton";
  updateAPI =  "/api/updturlcnfgrton";
  fieldOptionsAPI=  "/api/gtfldopts";
  crawlNowAPI=  "/api/gtcrwlddtlbycnfgrtonid";
  openCrawlAPI="/api/opncrwlddt"
  
  GetCrawlNow(data:any){
    return this.http.post(this.crawlNowAPI, data);
  }
  GetCountryOptions(jurisdictionId: any) {
    return this.http.post(this.countryOptionsAPI, jurisdictionId);
  }

  GetJurisdictionOptions(clientId : any) {
    return this.http.post(this.jurisdictionOptionsAPI, clientId);
  }
  GetRegionOptions(countryId: any) {
    return this.http.post(this.regionOptionsAPI, countryId);
  }

  GetRegulatorOptions(data: { JurisdictionIds: null; }) {
    return this.http.post(this.regulatorOptionsAPI, data);
  }

  GetRegulatorOptions_InsuranceACQ(data: { JurisdictionIds: null; }) {
    return this.http.post(this.regulatorOptionsAPI_InsuranceACQ, data);
  }

  GetDocTypeOptions(regulatorId: any) {
    return this.http.post(this.docTypeOptionsAPI, regulatorId);
  }

  GetDocTypeOptions_InsuranceACQ(regulatorId: any) {
    return this.http.post(this.docTypeOptionsAPI_InsuranceACQ, regulatorId);
  }

  GetIndustryOptions() {
    return this.http.post(this.industryOptionsAPI, null);
  }

  GetUpdateTypeOptions(clientId: any) {
    return this.http.post(this.updateTypeOptionsAPI, clientId);
  }

  GetSeleniumRequiredOptions() {
    return this.http.post(this.seleniumRequiredOptionsAPI, {});
  }

  GetClickEventTypeMasterData() {
    return this.http.post(this.clickEventTypeMasterAPI, {});
  }

  GetRegLakeStatusOptions(clientId : any) {
    return this.http.post(this.regLakeStatusOptionsAPI, clientId);
  }

  GetInsuranceAcquisitionRuleTypeOptions() {
    return this.http.post(this.insuranceAcquisitionRuleOptionsAPI, null);
  }

  GetScheduleOptions(clientMasterId:any) {
    return this.http.post(this.scheduleOptionsAPI, clientMasterId);
  }

  GetLangaugeOptions() {
    return this.http.post(this.langaugeOptionsAPI, null);
  }

  GetAssigneeOptions(clientMasterId: any) {
    return this.http.post(this.assigneeOptionsAPI, clientMasterId);
  }

  GetFieldOptions(clientMasterId: any) {
    return this.http.post(this.fieldOptionsAPI, clientMasterId);
  }

  GetFillingDateFormatMasterOptions(){
    return this.http.post(this.fillingDateFormatMasterOptions, null);
  }

  GetURLConfigurationById(id: any) {
    return this.http.post(this.urlConfigurationByIdAPI, id);
  }

  
  Add(detail: any) {
    return this.http.post(this.addAPI, detail);
  }

  Update(detail: any) {
    return this.http.post(this.updateAPI, detail);
  }

  OpenCrawl(detail:any){
    return this.http.post(this.openCrawlAPI,detail)
  }
}

